import { AutogenLayoutCityLookup } from "./autogen/AutogenLayoutCityLookup";

export class CityLookup extends AutogenLayoutCityLookup {

}
